import { StatusInterface } from '../Interfaces/PayNow/AccountAuthorizationParams'
import * as api from './apiHelper'

const PAY_NOW_URL = `/subscription/paynow`

export const postPayNowAuthorization = (authorizationCode: string) => {
  return api.Post(PAY_NOW_URL, { stripeAuthCode: authorizationCode })
}

export const getPayNowAuthorizationStatus = () => {
  return api.Get(PAY_NOW_URL)
}

export const putPayNowStatus = (status: StatusInterface) => {
  return api.Put(PAY_NOW_URL, status)
}

export const postPayment = (
  source,
  invoiceId: string,
  amount: number,
  currency: string,
  companyId: string,
  email: string,
) =>
  api.Post(`${PAY_NOW_URL}/charge`, { source, invoiceId, amount, currency, companyId: Number(companyId), email }, false)

export const createIntent = (invoiceId: string, amount: number, currency: string, companyId: string, email: string) =>
  api.Post(
    `/subscription/public/paynow/v2/intent`,
    { invoiceId, amount, currency, companyId: Number(companyId), email },
    false,
  )

export const getAccountId = (companyId: string) => api.Get(`/subscription/public/paynow/v2/account/${companyId}`, false)

export const disconnectPayNow = () => {
  return api.Delete(PAY_NOW_URL)
}
